import React from "react";

const WithdrawalMetricsCard = ({ summary, dayWiseData }) => {
	const d3Data = dayWiseData.slice(0, 4).reduce((acc, d) => ({
		users: acc.users + d.withdrawals.users,
		coins: acc.coins + d.withdrawals.coins
	}), { users: 0, coins: 0 });

	const d7Data = dayWiseData.slice(0, 8).reduce((acc, d) => ({
		users: acc.users + d.withdrawals.users,
		coins: acc.coins + d.withdrawals.coins
	}), { users: 0, coins: 0 });

	const metrics = [
		{
			label: "D0-D3 Withdrawals",
			users: d3Data?.users,
			coins: d3Data?.coins,
			icon: "🚀",
			color: "#3B82F6"
		},
		{
			label: "D0-D7 Withdrawals",
			users: d7Data?.users,
			coins: d7Data?.coins,
			icon: "📊",
			color: "#10B981"
		},
		{
			label: "D0-D15 Withdrawals",
			users: summary?.withdrawals?.d15_users,
			coins: summary?.withdrawals?.d15_coins,
			icon: "🏆",
			color: "#8B5CF6"
		},
		{
			label: "Median Withdrawal Day",
			users: summary?.withdrawals?.d15_users,
			day: summary?.withdrawals?.median_withdrawal_day,
			icon: "⏱️",
			color: "#F59E0B"
		}
	];

	return (
		<div>
			<div style={{ marginBottom: "20px" }}>
				<h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#1F2937" }}>
					🏦 Withdrawal Metrics
				</h3>
				<p style={{ margin: 0, fontSize: "13px", color: "var(--text-muted)" }}>
					User withdrawal behavior and cash-out patterns
				</p>
			</div>

			<div style={{
				display: "grid",
				gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
				gap: "var(--spacing-lg)"
			}}>
				{metrics.map((metric, idx) => (
					<div key={idx} style={{
						padding: "20px",
						backgroundColor: `${metric.color}15`,
						border: `2px solid ${metric.color}30`,
						borderRadius: "12px"
					}}>
						<div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
							<div style={{
								width: "48px",
								height: "48px",
								backgroundColor: metric.color,
								borderRadius: "12px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "24px"
							}}>
								{metric.icon}
							</div>
							<p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#1F2937" }}>
								{metric.label}
							</p>
						</div>

						{metric.day !== undefined ? (
							// Median day card
							<div>
								<p style={{ margin: "0 0 8px 0", fontSize: "36px", fontWeight: "700", color: metric.color }}>
									{metric.day !== null ? `D${metric.day}` : "N/A"}
								</p>
								<p style={{ margin: 0, fontSize: "13px", color: "#6B7280" }}>
									{metric?.users?.toLocaleString()} total withdrawals
								</p>
							</div>
						) : (
							// Regular withdrawal cards
							<div>
								<p style={{ margin: "0 0 4px 0", fontSize: "28px", fontWeight: "700", color: metric.color }}>
									{metric?.users?.toLocaleString()}
								</p>
								<p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#6B7280", fontWeight: "600" }}>
									users withdrew
								</p>
								<div style={{
									padding: "8px 12px",
									backgroundColor: "white",
									borderRadius: "6px",
									display: "inline-block"
								}}>
									<p style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#1F2937" }}>
										{(metric?.coins ?? 0).toFixed(0)} Coins
									</p>
								</div>
							</div>
						)}
					</div>
				))}
			</div>

			{/* Withdrawal Rate Breakdown */}
			<div style={{
				marginTop: "20px",
				padding: "16px",
				backgroundColor: "#F9FAFB",
				borderRadius: "8px"
			}}>
				<p style={{ margin: "0 0 12px 0", fontSize: "13px", fontWeight: "600", color: "#6B7280" }}>
					📊 Withdrawal Rate Progression
				</p>
				<div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
					<div style={{ flex: "1", minWidth: "150px" }}>
						<p style={{ margin: "0 0 4px 0", fontSize: "11px", color: "#6B7280" }}>D3 Rate</p>
						<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#3B82F6" }}>
							{((d3Data.users / summary.total_users) * 100).toFixed(2)}%
						</p>
					</div>
					<div style={{ flex: "1", minWidth: "150px" }}>
						<p style={{ margin: "0 0 4px 0", fontSize: "11px", color: "#6B7280" }}>D7 Rate</p>
						<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#10B981" }}>
							{((d7Data.users / summary.total_users) * 100).toFixed(2)}%
						</p>
					</div>
					<div style={{ flex: "1", minWidth: "150px" }}>
						<p style={{ margin: "0 0 4px 0", fontSize: "11px", color: "#6B7280" }}>D15 Rate</p>
						<p style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#8B5CF6" }}>
							{((summary?.withdrawals?.d15_users / summary?.total_users) * 100).toFixed(2)}%
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WithdrawalMetricsCard;